import React from "react";
import MediaShowcase from "./MediaShowcase";

const Header = ({
  title,
  subtitle,
  description,
  additionalText,
  date,
  location,
  mediaItems = [],
  showVideo = true,
  icons=[],
}) => {
  
  return (
    <div className="bg-gradient-to-r from-gray-100 to-gray-50 flex flex-col items-center justify-center  p-4 md:p-6  w-full">
      <div className="max-w-6xl w-full flex flex-col items-center gap-4 ">
        {/* Text Content */}

        {/* Description List */}
        <div className="mt-2 md:mt-4 bg-accent flex flex-col px-6 py-2 rounded-md shadow-md transition-all duration-200 hover:shadow-lg hover:scale-[1.02] items-center">
        <ul className="max-w-3xl md:text-left text-left space-y-3">
            {Array.isArray(description) ? (
              description.map((point, index) => (
                <li
                  key={index}
                  className="text-gray-700 font-semibold flex items-center gap-2"
                >
                  <span className="text-lg">{icons[index % icons.length]}</span>
                  <span className="text-sm md:text-lg">{point}</span>
                </li>
              ))
            ) : (
              <li className="text-center items-center text-gray-700">
                {description}
              </li>
            )}
          </ul>
        </div>

        {/* Media Showcase (Only render if mediaItems exist and showVideo is true) */}
        {mediaItems.length > 0 && showVideo && (
          <section className="py-6 md:py-6 mt-3 md:mt-4 w-full">
            <div className="w-full px-0">
              <MediaShowcase mediaItems={mediaItems} showVideo={showVideo} />
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default Header;
